import React from "react";

import "./index.scss";

export default function InstallationsCard({
  image,
  title,
  descr,
  name,
  id,
  setPickedItem,
}) {
  return (
    <div className="installations__block">
      <input type="radio" name={name} id={id} />
      <label
        htmlFor={id}
        className="installations__card"
        onClick={() => {
          setPickedItem(id);
        }}
      >
        <div className="image">
          <img src={image ? image : '/assets/images/empty-photo.svg'} alt="image" />
        </div>
        <div className="title">{title}</div>
        <div className="descr">{descr}</div>
        <div className="checked">
          <img src="/assets/icons/check-icon.svg" alt="mark" />
        </div>
      </label>
    </div>
  );
}
